<template>
    <edit-string
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :label="labelValue || $t('tax_year')"
        :placeholder="'YYYY'"
    >
        <template v-if="showNextYear" #append>
            <span class="body-2 mr-1" style="line-height: 1.5rem">{{ $t('to') }}</span>
            <span class="body-1">{{ nextYear || '-' }}</span>
        </template>
    </edit-string>
</template>

<script>
import BaseField from './BaseField';
export default {
    name: 'Year',
    extends: BaseField,
    props: {
        showNextYear: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        nextYear() {
            if (!this.showNextYear || !this.inputValue || this.inputValue.length !== 4) {
                return null;
            }

            return String(parseInt(this.inputValue) + 1);
        }
    },
    mounted() {
        this.rulesArray = [v => this.getValidator('year')(v, this.labelValue || this.$t('tax_year'))];
    }
};
</script>
